export const prefetchedScreens = new Set<string>();
